import React from "react";

const OfflineScreen = () => {
  return (
    <div style={styles.container}>
      <div>
        <h1 style={styles.title}>506</h1>
        <p style={styles.message}>
          Too many Requests. Please contact admin.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: "#000",
    color: "#fff",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "sans-serif",
    textAlign: "center",
  },
  title: {
    fontSize: "2rem",
    marginBottom: "0.5rem",
    fontWeight: "bold",
  },
  message: {
    fontSize: "1rem",
    opacity: 0.8,
  },
};

export default OfflineScreen;
